import { render, staticRenderFns } from "./DiffData.vue?vue&type=template&id=15f1027e&scoped=true"
import script from "./DiffData.vue?vue&type=script&lang=js"
export * from "./DiffData.vue?vue&type=script&lang=js"
import style0 from "./DiffData.vue?vue&type=style&index=0&id=15f1027e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f1027e",
  null
  
)

export default component.exports